import Banner from './Banner';
import Numbers from '../../../components/Numbers';
import News from './News';
import Press from './Press';
import MediaKit from './MediaKit';
import CommunicationTeam from './CommunicationTeam';

export { Banner, Numbers, News, Press, MediaKit, CommunicationTeam };
